import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, MessageCircle, Tag } from "lucide-react";

export default function MarketSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!sid) return;
    let cancelled = false;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/marketplace/checkout/status/${sid}`);
        if (cancelled) return;
        setOrder(data);
        if (data.payment_status !== "paid" && tries < 6) {
          tries += 1;
          setTimeout(poll, 1500);
        }
      } catch { /* ignore */ }
    };
    poll();
    return () => { cancelled = true; };
  }, [sid]);

  return (
    <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="market-success-page">
      <div className="h-16 w-16 mx-auto rounded-full bg-[#0A0A0A] text-white flex items-center justify-center">
        {order?.payment_status === "paid" ? <CheckCircle2 size={26}/> : <Loader2 size={22} className="animate-spin"/>}
      </div>
      <h1 className="font-heading text-3xl mt-5">
        {order?.payment_status === "paid" ? "Purchase confirmed." : "Confirming payment…"}
      </h1>
      {order?.payment_status === "paid" && (
        <>
          <p className="text-[#4A4A4A] mt-3">
            <strong>{order.listing_title}</strong> is yours. Message the seller to arrange delivery or pickup.
          </p>
          <div className="flex flex-col gap-2 mt-6">
            <Link to={`/messages/${order.seller_id}`} className="btn-primary justify-center" data-testid="market-success-message">
              <MessageCircle size={14}/> Message the seller
            </Link>
            <Link to="/market" className="btn-ghost justify-center" data-testid="market-success-keep-shopping">
              <Tag size={14}/> Keep shopping
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
